import styled from 'styled-components'

export const CardSlot = styled.div`
  width: 300px;
  min-width: 0;
`
